import { evaluateCondition } from "./conditions.js";
import { flatten } from "./flow.js";
/** Node types that can sit on a card; everything else stays one-at-a-time even inside a card step. */
export const CARD_NODE_TYPES = new Set([
    "text",
    "long_text",
    "email",
    "phone",
    "number",
    "date",
    "single_choice",
    "multi_choice",
]);
export function isCardStep(form, stepId) {
    return form.steps.find((s) => s.id === stepId)?.presentation === "card";
}
export function isCardNode(form, node) {
    return isCardStep(form, node.stepId) && CARD_NODE_TYPES.has(node.node.type);
}
/** The visible card fields of a step for the given (draft) answers, in order. */
export function cardNodes(form, stepId, answers) {
    if (!isCardStep(form, stepId))
        return [];
    return flatten(form).filter((f) => f.stepId === stepId &&
        CARD_NODE_TYPES.has(f.node.type) &&
        (!f.node.showIf || evaluateCondition(f.node.showIf, answers)));
}
/**
 * Collapses a transcript so that each card step appears as one system entry
 * (its title) followed by one combined answer group. Entries for nodes that
 * are not card nodes are passed through unchanged.
 */
export function groupTranscript(form, transcript) {
    const out = [];
    let open;
    for (const e of transcript) {
        if (isCardNode(form, e.node)) {
            if (e.kind === "system") {
                if (!open || open.stepId !== e.node.stepId) {
                    open = { kind: "card", stepId: e.node.stepId, stepTitle: e.node.stepTitle, entries: [] };
                    out.push(open);
                }
                continue;
            }
            if (!open || open.stepId !== e.node.stepId) {
                open = { kind: "card", stepId: e.node.stepId, stepTitle: e.node.stepTitle, entries: [] };
                out.push(open);
            }
            open.entries.push(e);
            continue;
        }
        open = undefined;
        out.push({ kind: "entry", entry: e });
    }
    return out;
}
//# sourceMappingURL=cards.js.map